import * as React from "react";

const SvgDrizzleSun = (props) => (
  <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg" {...props}>
    <defs>
      <clipPath clipPathUnits="userSpaceOnUse" id="DrizzleSun_svg__a">
        <path d="M741.455 220.954a1.5 1.5 0 1 1 0-3h10a1.5 1.5 0 0 1 0 3z" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="DrizzleSun_svg__b">
        <path d="M757.955 220.954a1.5 1.5 0 0 1-1.501-1.5c0-.828.673-1.5 1.501-1.5h15a1.5 1.5 0 0 1 0 3z" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="DrizzleSun_svg__c">
        <path d="M741.455 212.954a1.5 1.5 0 1 1 0-3h20a1.5 1.5 0 0 1 0 3z" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="DrizzleSun_svg__d">
        <path d="M767.955 212.954a1.5 1.5 0 0 1-1.501-1.5c0-.828.673-1.5 1.501-1.5h15a1.5 1.5 0 0 1 0 3z" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="DrizzleSun_svg__e">
        <path d="M917.757 257.718c0-7.159 5.805-12.964 12.964-12.964 7.159 0 12.963 5.805 12.963 12.964 0 7.159-5.804 12.962-12.963 12.962-7.159 0-12.964-5.803-12.964-12.962" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="DrizzleSun_svg__f">
        <path d="M0 943.388h1828.656V0H0Z" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="DrizzleSun_svg__g">
        <path d="M922.177 244.882c-.053.001-.105.003-.159.003a8.287 8.287 0 0 1 0-16.574h20.6a6.696 6.696 0 0 1 0 13.392c-.023 0-.045-.003-.069-.003-.596 5.34-5.122 9.493-10.622 9.493-4.341 0-8.077-2.591-9.75-6.311" />
      </clipPath>
    </defs>
    <g
      clipPath="url(#DrizzleSun_svg__a)"
      transform="matrix(1.33333 0 0 -1.33333 -969.94 367.51)"
      style={{
        fill: "#00b6f1",
        fillOpacity: 1,
      }}
    >
      <g
        style={{
          fill: "#00b6f1",
          fillOpacity: 1,
        }}
      >
        <path
          d="M741.455 220.954a1.5 1.5 0 1 1 0-3h10a1.5 1.5 0 0 1 0 3z"
          style={{
            fill: "#00b6f1",
            stroke: "none",
            fillOpacity: 1,
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#DrizzleSun_svg__b)"
      transform="matrix(1.33333 0 0 -1.33333 -969.94 367.51)"
      style={{
        fill: "#00b6f1",
        fillOpacity: 1,
      }}
    >
      <g
        style={{
          fill: "#00b6f1",
          fillOpacity: 1,
        }}
      >
        <path
          d="M757.955 220.954a1.5 1.5 0 0 1-1.501-1.5c0-.828.673-1.5 1.501-1.5h15a1.5 1.5 0 0 1 0 3z"
          style={{
            fill: "#00b6f1",
            stroke: "none",
            fillOpacity: 1,
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#DrizzleSun_svg__c)"
      transform="matrix(1.33333 0 0 -1.33333 -969.94 367.51)"
      style={{
        fill: "#00b8f1",
        fillOpacity: 1,
      }}
    >
      <g
        style={{
          fill: "#00b8f1",
          fillOpacity: 1,
        }}
      >
        <path
          d="M741.455 212.954a1.5 1.5 0 1 1 0-3h20a1.5 1.5 0 0 1 0 3z"
          style={{
            fill: "#00b8f1",
            stroke: "none",
            fillOpacity: 1,
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#DrizzleSun_svg__d)"
      transform="matrix(1.33333 0 0 -1.33333 -969.94 367.51)"
      style={{
        fill: "#00b8f1",
        fillOpacity: 1,
      }}
    >
      <g
        style={{
          fill: "#00b8f1",
          fillOpacity: 1,
        }}
      >
        <path
          d="M767.955 212.954a1.5 1.5 0 0 1-1.501-1.5c0-.828.673-1.5 1.501-1.5h15a1.5 1.5 0 0 1 0 3z"
          style={{
            fill: "#00b8f1",
            stroke: "none",
            fillOpacity: 1,
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#DrizzleSun_svg__e)"
      transform="matrix(1.33333 0 0 -1.33333 -1173.141 369.335)"
      style={{
        fill: "#fec424",
        fillOpacity: 1,
      }}
    >
      <g
        style={{
          fill: "#fec424",
          fillOpacity: 1,
        }}
      >
        <path
          d="M917.757 257.718c0-7.159 5.805-12.964 12.964-12.964 7.159 0 12.963 5.805 12.963 12.964 0 7.159-5.804 12.962-12.963 12.962-7.159 0-12.964-5.803-12.964-12.962"
          style={{
            fill: "#fec424",
            stroke: "none",
            fillOpacity: 1,
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#DrizzleSun_svg__f)"
      transform="matrix(1.33333 0 0 -1.33333 -1173.141 369.335)"
      style={{
        fill: "#eef0f5",
        fillOpacity: 1,
      }}
    >
      <g
        style={{
          fill: "#eef0f5",
          fillOpacity: 1,
        }}
      >
        <path
          d="M0 0c5.889 0 10.664 4.774 10.664 10.664S5.889 21.328 0 21.328c-.037 0-.072-.005-.109-.006-.949 8.504-8.158 15.117-16.915 15.117-6.915 0-12.864-4.126-15.528-10.048-.085.001-.168.005-.253.005-7.289 0-13.198-5.909-13.198-13.198C-46.003 5.909-40.094 0-32.805 0"
          style={{
            fill: "#eef0f5",
            fillOpacity: 1,
            fillRule: "nonzero",
            stroke: "none",
          }}
          transform="translate(928.4 228.31)"
        />
      </g>
    </g>
    <g
      clipPath="url(#DrizzleSun_svg__g)"
      transform="matrix(1.33333 0 0 -1.33333 -1173.141 369.335)"
      style={{
        fill: "#dcecf9",
        fillOpacity: 1,
      }}
    >
      <g
        style={{
          fill: "#dcecf9",
          fillOpacity: 1,
        }}
      >
        <path
          d="M922.177 244.882c-.053.001-.105.003-.159.003a8.287 8.287 0 0 1 0-16.574h20.6a6.696 6.696 0 0 1 0 13.392c-.023 0-.045-.003-.069-.003-.596 5.34-5.122 9.493-10.622 9.493-4.341 0-8.077-2.591-9.75-6.311"
          style={{
            fill: "#dcecf9",
            stroke: "none",
            fillOpacity: 1,
          }}
        />
      </g>
    </g>
    <path
      style={{
        opacity: 0.996721,
        fill: "none",
        stroke: "none",
        strokeWidth: 0.878738,
        strokeLinejoin: "round",
        paintOrder: "stroke fill markers",
      }}
      transform="matrix(1.33333 0 0 1.33333 1280 -38.15)"
      d="M-960 28.612h72v72h-72z"
    />
  </svg>
);

export default SvgDrizzleSun;
